// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PLineChartOutlinedSvg from "@fishx/icons-svg/es/asn/PLineChartOutlined";
import FishxIcon from '../components/FishxIcon';

var PLineChartOutlined = function PLineChartOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PLineChartOutlinedSvg
  }));
};

PLineChartOutlined.displayName = 'PLineChartOutlined';
export default React.forwardRef(PLineChartOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PLineChartOutlined.js
// module id = 3483
// module chunks = 0